const rows = [
  { feature: 'Fee Transparency', fore: 'Full itemization — every fee visible', traditional: 'Bundled rates, hidden markups' },
  { feature: 'Implementation', fore: 'Embedded specialist, 30–60 days', traditional: 'Self-service setup, minimal support' },
  { feature: 'Reporting', fore: 'Real-time dashboard, actionable insights', traditional: 'End-of-day batch reports, limited data' },
  { feature: 'Payout Schedule', fore: 'Predictable, consistent deposits', traditional: 'Variable timing, random holds' },
  { feature: 'Fraud Protection', fore: 'Catches real threats without blocking good customers', traditional: 'Basic rules, high false declines' },
  { feature: 'Custom Infrastructure', fore: 'Built around your business model', traditional: 'One-size-fits-all templates' },
  { feature: 'Support', fore: 'Dedicated account specialist, 24/7', traditional: 'Call center queues, ticket systems' },
  { feature: 'Contract Terms', fore: 'Month-to-month, no early termination', traditional: 'Multi-year lock-in, hefty penalties' },
];

export default function ComparisonTable() {
  return (
    <section className="bg-[#F9F9F7] py-28 px-5 md:px-[75px]">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <p
            className="text-[#a8894a] text-[10px] uppercase tracking-[0.25em] font-medium mb-5"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            The Difference
          </p>
          <h2
            className="text-[#061e45] text-4xl md:text-5xl lg:text-[54px] font-light leading-[1.1]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Fore Capital vs. The Rest.
          </h2>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-[#061e45]">
                <th
                  className="text-left py-5 px-6 text-[#1A1A1A]/40 text-[10px] uppercase tracking-[0.2em] font-medium w-[30%]"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                >
                  Feature
                </th>
                <th
                  className="text-left py-5 px-6 text-[#061e45] text-[10px] uppercase tracking-[0.2em] font-semibold w-[35%]"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                >
                  Fore Capital
                </th>
                <th
                  className="text-left py-5 px-6 text-[#1A1A1A]/40 text-[10px] uppercase tracking-[0.2em] font-medium w-[35%]"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                >
                  Traditional Processors
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr
                  key={row.feature}
                  className={`border-b ${i % 2 === 0 ? 'bg-white' : 'bg-[#F9F9F7]'} hover:bg-[#061e45]/3 transition-colors duration-200`}
                >
                  <td
                    className="py-5 px-6 text-[#061e45] text-[15px] font-medium"
                    style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                  >
                    {row.feature}
                  </td>
                  <td className="py-5 px-6">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-[#a8894a] text-sm mt-0.5 shrink-0" />
                      <span
                        className="text-[#1A1A1A]/70 text-[15px]"
                        style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
                      >
                        {row.fore}
                      </span>
                    </div>
                  </td>
                  <td className="py-5 px-6">
                    <div className="flex items-start gap-3">
                      <i className="ri-close-line text-[#1A1A1A]/20 text-sm mt-0.5 shrink-0" />
                      <span
                        className="text-[#1A1A1A]/40 text-[15px]"
                        style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
                      >
                        {row.traditional}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
